import React from "react";
import { Trans } from "react-i18next";

import {
  Callout,
  Button,
  Intent,
  InputGroup,
  Tag,
  Dialog,
  Classes,
  FormGroup,
  HTMLSelect,
  Checkbox
} from "@blueprintjs/core";

import {
  Cell,
  Column,
  ColumnHeaderCell,
  RowHeaderCell,
  Table2,
  EditableCell2
} from "@blueprintjs/table";

import {
  authenticatedGetFetch
} from "../../utils/AuthenticatedFetch";
import {
  EacAuthenticatedGetFetch,
  EacAuthenticatedPutFetch
} from "../../utils/ExternalAccessControlAuthenticatedFetch";
import i18n from "../../i18n";

export default class DeviceIdTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      parks: [],
      devices: [],
      devicesId: [],
      editing: -1,
      externalIdChange : false,
    };
  }

  componentDidMount() {
    this.updateTable();
  }

  updateTable() {
    EacAuthenticatedGetFetch(`/${this.props.target}/ids`, (response)=>{
      this.setState({ devicesId: response },
        () => authenticatedGetFetch('/parks', (response) => {
          const parks = {};
          for (const park of response)
            parks[park.id] = park.name !== null ? park.id + " - " + park.name : park.id;
          this.setState({ parks: parks }, 
            () => authenticatedGetFetch('/devices', (response) => {
                this.setState({ devices: response });
            })
          );
        })
      )
    });

    /* */
    // authenticatedGetFetch('/parks', (response) => {
    //   const parks = {};
    //   for (const park of response)
    //     parks[park.id] = park.name !== null ? park.id + " - " + park.name : park.id;
    //   this.setState({ parks: parks }, 
    //     () => authenticatedGetFetch('/devices', (response) => 
    //         this.setState({ devices: response }, 
    //             ()=>EacAuthenticatedGetFetch(`/${this.props.target}/ids`, (response)=>{
    //                 this.setState({ devicesId: response })
    //             })
    //         )
    //     )
    //   );
    // });
  }

  getExternalIdByDevicePK(pk){
    return this.state.devicesId[pk] ?? "";
  }

  setExternalIdByDevicePK(value, devicePk){
    const devices = [...this.state.devicesId];
    if(value === '')
      delete devices[devicePk];
    else
      devices[devicePk] = value;

    if(!this.state.externalIdChange)
      this.setState({externalIdChange: true, devicesId: devices});
    else
      this.setState({devicesId: devices});
  }

  disableSaveButton(){
    return !this.state.externalIdChange;
  }

  saveConfig(){
    const data = [];
    Object.keys(this.state.devicesId).forEach(d => {
      const deviceTable = this.state.devices.find(dt => {return dt.pk === Number(d)});
      if(deviceTable){
        data.push({
          equipmentPk: deviceTable.pk,
          id : deviceTable.id,
          name: deviceTable.name,
          parkId: deviceTable.park.id,
          parkName: deviceTable.park.name,
          externalId: this.state.devicesId[d],
        })
      }
    });
    EacAuthenticatedPutFetch(`/${this.props.target}/ids`, data, ()=>{
        this.setState({externalIdChange: false});
    })
  }

  render() {
    return <Callout title={<Trans>devices</Trans>}>
      <Callout intent="primary">devices are automatically created if missing when a state is received</Callout>

      {/* editing dialog */}
      <Dialog
        style={{ transition: 'none' }}
        isOpen={this.state.editing >= 0}
        onClose={() => this.setState({ editing: -1, creating_error: false })}
        title={<Trans>edit device</Trans>}
      >
        {this.state.editing >= 0 &&
          <div className={Classes.DIALOG_BODY}>
            <form onSubmit={e => {
              e.preventDefault(); // to avoid reload of the page on submit
            //   authenticatedPutFetch("/device/" + this.state.devices[this.state.editing]["park"]["server"]["id"] + "/" + this.state.devices[this.state.editing]["id"], {
            //     name: this.state.input_name,
            //     type: this.state.input_type,
            //     display: this.state.input_display,
            //     camera: this.state.input_camera,
            //     generation: this.state.input_generation
            //   }, () => this.setState({ editing: -1, creating_error: false }, () => this.updateTable()),
            //     () => this.setState({ creating_error: true }));
            }}>
              <p><Trans>server</Trans><Trans>:</Trans><Tag large={true}>{this.state.devices[this.state.editing]["park"]["server"]["name"]}</Tag></p>
              <p><Trans>park</Trans><Trans>:</Trans><Tag large={true}>{this.state.parks[this.state.devices[this.state.editing]["park"]["id"]]}</Tag></p>
              <p><Trans>device id</Trans><Trans>:</Trans><Tag large={true}>{this.state.devices[this.state.editing]["id"]}</Tag></p>

              <FormGroup label={<Trans>label</Trans>} labelFor="input_name" inline={true}>
                <InputGroup id="input_name" intent={this.state.creating_error ? "danger" : "normal"}
                  onChange={(ti) => this.setState({ input_name: ti.target.value })}
                  value={this.state.input_name}
                />
              </FormGroup>

              <FormGroup
                label={<Trans>device type</Trans>}
                helperText="used to switch icon on supervison and for statistics"
                labelFor="input_type"
                inline={true}
              >
                <HTMLSelect
                  id="input_type"
                  options={[
                    { value: "BE", label: i18n.t("BE") },
                    { value: "CM", label: i18n.t("CM") },
                    { value: "LP", label: i18n.t("LP") },
                    { value: "CA", label: i18n.t("CA") },
                    { value: "BS", label: i18n.t("BS") }
                  ]}
                  onChange={(ti) => this.setState({ input_type: ti.target.value })}
                  value={this.state.input_type}
                />
                <HTMLSelect
                  options={[
                    { value: "300", label: "Gamme 300" },
                    { value: "400", label: "Gamme 400" }
                  ]}
                  onChange={(ti) => this.setState({ input_generation: ti.target.value })}
                  value={this.state.input_generation}
                />
              </FormGroup>

              <FormGroup
                label={<Trans>display</Trans>}
                helperText="display on supervision page and envent flow"
                labelFor="input_display"
                inline={true}
              >
                <Checkbox id="input_display" intent={this.state.creating_error ? "danger" : "normal"} type="number"
                  onChange={(ti) => this.setState({ input_display: ti.target.checked })}
                  checked={this.state.input_display}
                />
              </FormGroup>

              <FormGroup label={<Trans>camera</Trans>} labelFor="input_camera" inline={true}>
                <InputGroup id="input_camera" intent={this.state.creating_error ? "danger" : "normal"}
                  onChange={(ti) => this.setState({ input_camera: ti.target.value })}
                  value={this.state.input_camera}
                />
              </FormGroup>

              <Button
                text={<Trans>edit</Trans>}
                intent="primary"
                icon="edit"
                type="submit"
              />
            </form>
          </div>}
      </Dialog>

      <Table2
        cellRendererDependencies={[this.state.devices]}
        numRows={this.state.devices.length}
        rowHeaderCellRenderer={(rowIndex) => <RowHeaderCell index={rowIndex} name={this.state.devices[rowIndex]["id"]} />}
      >
        {/* park */}
        <Column
          id="park"
          cellRenderer={(rowIndex) => {
            if (this.state.devices[rowIndex]["park"])
              return <Cell>{this.state.parks[this.state.devices[rowIndex]["park"]["id"]]}</Cell>
            else
              return <Cell></Cell>
          }}
          columnHeaderCellRenderer={() => <ColumnHeaderCell name={<Trans>park</Trans>} />}
        />

        {/* label */}
        <Column
          id="label"
          cellRenderer={(rowIndex) => <Cell>{this.state.devices[rowIndex]["name"]}</Cell>}
          columnHeaderCellRenderer={() => <ColumnHeaderCell name={<Trans>label</Trans>} />}
        />

        {/* type */}
        <Column
          id="type"
          cellRenderer={(rowIndex) => <Cell><Trans>{this.state.devices[rowIndex]["type"]}</Trans></Cell>}
          columnHeaderCellRenderer={() => <ColumnHeaderCell name={<Trans>device type</Trans>} />}
        />

        {/* generation */}
        <Column
          id="generation"
          cellRenderer={(rowIndex) => {
                return (
                <EditableCell2
                    value={this.getExternalIdByDevicePK(this.state.devices[rowIndex]["pk"])}
                    onChange={(val) => { this.setExternalIdByDevicePK(val, this.state.devices[rowIndex]["pk"]); }}
                >
                    
                </EditableCell2>);
          }}
          columnHeaderCellRenderer={() => <ColumnHeaderCell name={<Trans>external Id</Trans>} />}
        />
      </Table2>
      <br/>
      <div className="flexbox-right">
        <Button
            text={<Trans>edit</Trans>}
            icon="send-to"
            intent={Intent.WARNING}
            type="submit"
            disabled={this.disableSaveButton()}
            onClick={() => { this.saveConfig()}}
            />
        </div>
    </Callout>
  }
}